import translations from "./translations/index.js";

export default {
    ...translations,
};
